import { Link, useNavigate } from "react-router-dom";

export default function Header() {

let navigate = useNavigate();

const doLogout = () => {
  navigate('/');
  localStorage.removeItem('apiSesionId');
};


    return(

        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
    {/* <!-- Left navbar links --> */}
    <ul className="navbar-nav">
      <li className="nav-item">
        <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
      </li>
      <li className="nav-item d-none d-sm-inline-block">
        <Link to="/raffles"className="nav-link">Sorteos</Link>
      </li>
      <li className="nav-item d-none d-sm-inline-block">
      <Link to="/add-raffle"className="nav-link"><i className="fas fa-plus"></i> Crear Sorteo</Link>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a href="#" onClick={doLogout} className="nav-link"><i class="fas fa-sign-out-alt"></i> Cerrar Sesión</a>
      </li>
    </ul>
  </nav>
    );

}